import Button from 'molecules/Button';

import Hamburger from 'layout/header/components/hamburger';

import { hasArrayValues } from 'utils/array/arrays';

import type { FC } from 'react';

interface HeaderButtonProps {
  callToAction?: MenuItem[];
  loginLink?: {
    label: string;
    link: string;
  }[];
}

const HeaderButtons: FC<HeaderButtonProps> = ({ callToAction, loginLink }) => (
  <div className="flex items-center gap-4">
    <div className="hidden items-center gap-8 xl:flex">
      {hasArrayValues(loginLink) &&
        loginLink.map(link => (
          <a
            key={link.label}
            href={link.link}
            className="relative z-10 whitespace-nowrap font-roboto text-md font-medium text-primary-1400 hover:text-primary-1600"
          >
            {link.label}
          </a>
        ))}
      <div className="flex items-center gap-4">
        {hasArrayValues(callToAction) &&
          callToAction.map((button, index) => (
            <Button
              key={button.label}
              label={button.label}
              href={button.link}
              hierarchy={index === 0 ? 'secondary' : 'primary'}
              forceSmallerSize
              useCustomColors={button.useCustomColors}
              useGradient={button.useGradient}
              bgColor={button.bgColor}
              hoverBgColor={button.hoverBgColor}
              gradientFrom={button.gradientFrom}
              gradientTo={button.gradientTo}
              hoverGradientFrom={button.hoverGradientFrom}
              hoverGradientTo={button.hoverGradientTo}
              textColor={button.textColor}
              borderColor={button.borderColor}
              focusRingColor={button.focusRingColor}
            />
          ))}
      </div>
    </div>
    <Hamburger />
  </div>
);

export default HeaderButtons;
